import UsersTableModule from './UsersTable.module';

export * from './UsersTableModuleProps';
export * from './UsersTableRef';
export default UsersTableModule;
